export class OrderLog {
    id: number;
    
    order_id: number;
    user_id: number;

    type: string;
    data: string;
    
    created_at: string;
    updated_at: string;
}


// WEBPACK FOOTER //
// /var/www/vhosts/vinologiwijnen.nl/httpdocs/crm/resources/assets/src/app/shared/models/shop/order_log.ts